import { createSelector } from '@reduxjs/toolkit'
import { buildFlightDateChangeCartEvaluationItems } from 'businessTraveller/utils/buildFlightDateChangeCartEvaluationItems'
import { selectIsFlightChangeDateTripRequestEnabled } from 'businessTraveller/selectors/selectIsFlightChangeDateTripRequestEnabled'
import { selectFlightDateChangeOrderTravellers } from 'businessTraveller/selectors/selectFlightDateChangeOrderTravellers'
import { getFlightItemsView } from 'checkout/selectors/view/flights'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

// The flight date change checkout evaluates the whole cart as the one date change line.
export const selectIsFlightDateChangeCartEvaluation = createSelector(
  (state: App.State) => selectIsFlightChangeDateTripRequestEnabled(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (isFlowEnabled, postPurchase): boolean => isFlowEnabled && postPurchase === 'flight-change-dates',
)

export const getFlightDateChangeCartEvaluationItems = createSelector(
  (state: App.State) => state.geo.currentCurrency,
  (state: App.State) => selectFlightDateChangeOrderTravellers(state),
  (state: App.State) => getFlightItemsView(state),
  (
    currencyCode,
    orderTravellers,
    flightItemsViews,
  ): App.WithDataStatus<Array<CartEvaluationItemInputWire>> => {
    return {
      hasRequiredData: flightItemsViews.hasRequiredData && orderTravellers.length > 0,
      data: buildFlightDateChangeCartEvaluationItems({
        flightItemsViews,
        currencyCode,
        orderTravellers,
      }),
    }
  },
)
